import { useEffect, useState } from "react";
import commitmentScannerService from "../../../services/commitmentScannerService";
import { playerName, profileNow } from "./scannerLabels";

// Choose which JUCO Pipeline profile a scanned player belongs to.
export const PickProfileModal = ({ result, onClose, onPick, busy }) => {
  const [query, setQuery] = useState(result.playerName || "");
  const [found, setFound] = useState([]);
  const [searching, setSearching] = useState(false);

  useEffect(() => {
    const q = query.trim();
    if (q.length < 2) {
      setFound([]);
      return undefined;
    }
    const t = setTimeout(async () => {
      setSearching(true);
      try {
        const data = await commitmentScannerService.searchPlayers(q);
        setFound(data.players || []);
      } catch {
        setFound([]);
      } finally {
        setSearching(false);
      }
    }, 300);
    return () => clearTimeout(t);
  }, [query]);

  const candidates = result.matchCandidates || [];
  const Row = ({ p }) => (
    <button
      disabled={busy}
      onClick={() => onPick(p._id)}
      className="w-full text-left px-3 py-2 rounded-lg bg-jp-section hover:bg-jp-line disabled:opacity-40"
    >
      <div className="text-jp-ink">{playerName(p)}</div>
      <div className="text-xs text-jp-muted">
        {p.team?.name || "No team"} · {profileNow(p)}
        {p.xURL ? ` · ${p.xURL}` : ""}
      </div>
    </button>
  );

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4" onClick={onClose}>
      <div
        className="w-full max-w-lg max-h-[90vh] overflow-y-auto rounded-2xl border border-jp-line bg-jp-card p-6 text-sm text-jp-ink space-y-4"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start justify-between">
          <div>
            <h3 className="text-lg font-semibold text-jp-ink">Which profile is this?</h3>
            <p className="text-xs text-jp-muted">
              {result.playerName} · @{result.twitterUsername}
              {result.currentSchool ? ` · ${result.currentSchool}` : ""}
            </p>
          </div>
          <button onClick={onClose} className="text-jp-muted hover:text-jp-ink text-xl leading-none">×</button>
        </div>

        {candidates.length > 0 && (
          <div className="space-y-2">
            <div className="text-xs uppercase tracking-wide text-jp-muted">Possible matches</div>
            {candidates.map((p) => <Row key={p._id} p={p} />)}
          </div>
        )}

        <div className="space-y-2">
          <div className="text-xs uppercase tracking-wide text-jp-muted">Search players</div>
          <input
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Player name"
            className="w-full h-9 rounded-lg bg-jp-section border border-jp-line px-3 text-jp-ink placeholder:text-jp-muted"
          />
          {searching && <p className="text-xs text-jp-muted">Searching…</p>}
          {!searching && query.trim().length >= 2 && found.length === 0 && (
            <p className="text-xs text-jp-muted">No players found.</p>
          )}
          {found.map((p) => <Row key={p._id} p={p} />)}
        </div>

        {result.player && (
          <button disabled={busy} onClick={() => onPick(null)} className="text-xs text-red-600 dark:text-red-300 hover:text-red-200">
            Not on JUCO Pipeline — clear the match
          </button>
        )}
      </div>
    </div>
  );
};
